import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';
import { getFriendlyTime } from '@zorba-shared/core/Services/textService';
import { buildBuyerPageUrl } from '../../../../services/urlBuilderService';
import { showSuccessToast } from '../../../../services/notificationsService';
import { ZorbaSelect } from '../../../../components/forms';

export const ADMIN_USERS = [
  'anj@getzorba.com',
  'or@getzorba.com',
  'kobi@getzorba.com',
  'mateusz.kwasny@getzorba.com',
];

export const getAccessibleAgents = (userEmail, userId, agents = [], userDetails) => {
  if (!userDetails) return;
  if (userDetails.permissions.includes('admin') || userDetails.permissions.includes('superuser')) {
    return [{ label: 'All Agents', value: '' }, ...agents];
  }

  return agents.filter((agent) => agent.value === userId);
};

export const getTableColumns = ({
  isAdmin,
  editingKey,
  setEditingKey,
  handleAssociatedAgentChange,
  tempValue,
  agents = [],
}) => [
  {
    title: 'Partner',
    key: 'contactName',
    render: ({ contactName, contactOrganization, contactId }) => (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Link
          style={{
            color: '#3F434A',
            fontWeight: '500',
            fontSize: '14px',
            cursor: 'pointer',
          }}
          to={buildBuyerPageUrl({ userDetails: { _id: contactId } })}
          target="_blank"
          rel="noopener noreferrer"
        >
          {contactName}
        </Link>
        <span style={{ color: '#8A9099', fontSize: '10px' }}>
          {contactOrganization}
        </span>
      </div>
    ),
  },
  {
    title: 'Actions',
    key: 'actions',
    width: 80,
    render: ({ contactOwnerId, contactId }, _, index) => (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {contactOwnerId && (
          <button
            onClick={() => handleAssociatedAgentChange(index, contactId, null)}
            style={{
              background: 'none',
              border: '1px solid #d9d9d9',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '12px',
              color: '#666',
              padding: '4px 8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '60px',
              height: '24px'
            }}
            title="Clear contact owner"
            onMouseEnter={(e) => {
              e.target.style.background = '#f5f5f5';
              e.target.style.color = '#333';
              e.target.style.borderColor = '#1890ff';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'none';
              e.target.style.color = '#666';
              e.target.style.borderColor = '#d9d9d9';
            }}
          >
            Clear
          </button>
        )}
      </div>
    ),
  },
  {
    title: 'Contact owner',
    key: 'contactOwner',
    render: ({ contactOwner, contactOwnerId, contactId }, _, index) =>
      isAdmin && editingKey === `${index}-contactOwner` ? (
        <div style={{ width: '200px', position: 'relative' }}>
          <ZorbaSelect
            value={tempValue || contactOwnerId}
            options={agents}
            onChange={(e) => handleAssociatedAgentChange(index, contactId, e)}
            onBlur={() => setEditingKey(null)}
          />
          {(tempValue || contactOwnerId) && (
            <button
              onClick={() => handleAssociatedAgentChange(index, contactId, null)}
              style={{
                position: 'absolute',
                right: '8px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '14px',
                color: '#999',
                padding: '0',
                width: '16px',
                height: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10
              }}
              title="Clear selection"
            >
              ×
            </button>
          )}
        </div>
      ) : (
        <span
          onClick={() => isAdmin && setEditingKey(`${index}-contactOwner`)}
          style={{ cursor: isAdmin ? 'pointer' : 'default' }}
        >
          {contactOwner}
        </span>
      ),
  },
  {
    title: 'Last login',
    key: 'lastLogin',
    sorter: (a, b) => new Date(a.lastLogin) - new Date(b.lastLogin),
    render: ({ lastLogin }) => getFriendlyTime(lastLogin),
  },
  {
    title: 'Deals submitted',
    key: 'dealsSubmitted',
    sorter: (a, b) => a.dealsSubmitted - b.dealsSubmitted,
    render: ({ dealsSubmitted }) => dealsSubmitted,
  },
  {
    title: 'Last deal submitted at',
    key: 'lastDealSubmittedAt',
    sorter: (a, b) =>
      new Date(a.lastDealSubmittedAt) - new Date(b.lastDealSubmittedAt),
    render: ({ lastDealSubmittedAt }) => getFriendlyTime(lastDealSubmittedAt),
  },
  {
    title: 'Offers received',
    key: 'offersReceived',
    sorter: (a, b) => a.offersReceived - b.offersReceived,
    render: ({ offersReceived }) => offersReceived,
  },
  {
    title: 'Offers accepted',
    key: 'offersAccepted',
    sorter: (a, b) => a.offersAccepted - b.offersAccepted,
    render: ({ offersAccepted }) => offersAccepted,
  },
  {
    title: 'Phone number',
    key: 'phoneNumber',
    render: ({ phoneNumber }) => (
      <Tooltip title="Click to copy">
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => {
            navigator.clipboard.writeText(phoneNumber);
            showSuccessToast('Phone number copied to clipboard!');
          }}
        >
          {phoneNumber}
        </span>
      </Tooltip>
    ),
  },
  {
    title: 'Email',
    key: 'email',
    render: ({ email }) => (
      <Tooltip title="Click to copy">
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => {
            navigator.clipboard.writeText(email);
            showSuccessToast('Email copied to clipboard!');
          }}
        >
          {email}
        </span>
      </Tooltip>
    ),
  },
];
